import { defineStore } from 'pinia'
import { inject, markRaw } from 'vue'

import { createVisualAccount } from '../composables'

const useVisualAccountStore = defineStore('visual-account', () => {
  const api = inject('api')
  if (!api) throw new Error('Visual account store: api provider is required')

  const i18nRuntime = inject('i18nRuntime')
  if (!i18nRuntime) throw new Error('Visual account store: i18nRuntime provider is required')
  const analytics = inject('analytics')
  if (!analytics) throw new Error('Visual account store: analytics provider is required')

  return {
    account: markRaw(createVisualAccount(api, {
      analytics,
      getLocale: () => i18nRuntime.getLocale(),
    })),
  }
})

export function useVisualAccount() {
  return useVisualAccountStore().account
}
